import { COUNTRY_CODE } from '@/config'
import { sanitizeCnpjInput } from '../formatters'

type MaskFunction = (value: string) => string

export const masks: Record<string, MaskFunction> = {
  cellphone: (value: string): string => {
    return value
      .replace(/[^0-9+]/g, '')
      .replace(/(\+\d{2})(\d)/g, '$1 $2')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(\d{4})-(\d{4})$/, '$1-$2')
  },
  phone: (value: string): string => {
    return value
      .replace(/\D+/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
      .replace(/(-\d{4})\d+?$/, '$1')
  },
  cnpj: (value: string): string => {
    return sanitizeCnpjInput(value)
      .replace(/^(.{2})(.)/, '$1.$2')
      .replace(/^(.{2})\.(.{3})(.)/, '$1.$2.$3')
      .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, '$1.$2.$3/$4')
      .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.)/, '$1.$2.$3/$4-$5')
  },
  cpf: (value: string): string => {
    return value
      .replace(/\D+/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  },
  zipcode: (value: string): string => {
    return value
      .replace(/\D+/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1')
  },
  onlyDigits: (value: string): string => {
    return value.replace(/\D+/g, '')
  },
}

export const realTimeTypingPhoneMask = (value?: string): string => {
  const numbersOnly = value?.replace(/\D/g, '')
  let formatted = COUNTRY_CODE

  if (!numbersOnly || numbersOnly.length < 2) return formatted

  if (numbersOnly.length > 2) {
    formatted += ' (' + numbersOnly.substring(2, 4)
  }
  if (numbersOnly.length > 4) {
    formatted += ') ' + numbersOnly.substring(4, 13)
  }

  return formatted
}
